document.addEventListener('DOMContentLoaded', function() {
  // console.log('DOM Content Loaded');
  const zoomContainers = document.querySelectorAll('.product-item__image-wrapper--zoom');
  // console.log('Found zoom containers:', zoomContainers.length);
  
  zoomContainers.forEach((container, index) => {
    // console.log(`Setting up container ${index}`);
    const image = container.querySelector('.product-item__primary-image');
    // console.log('Found image:', image);
    
    // Find the info bottom element (closest parent with product-item-wrapper, then find the info bottom within it)
    const productWrapper = container.closest('.product-item-wrapper');
    const infoBottom = productWrapper ? productWrapper.querySelector('.product-item__info--bottom') : null;
    
    // Add transition property to the image
    image.style.transition = 'transform 0.3s ease-out, transform-origin 0.3s ease-out';
    
    // Add transition to info bottom if it exists
    if (infoBottom) {
      infoBottom.style.transition = 'opacity 0.3s ease-out';
    }
    
    container.addEventListener('mouseenter', function() {
      // console.log('Mouse entered container', index);
      container.classList.add('zoomed');
      image.style.transform = 'scale(3)';
      image.style.cursor = 'zoom-in';
      
      // Hide the info bottom except for add to cart
      if (infoBottom) {
        // Either hide completely
        infoBottom.style.opacity = '0';
        // Or just hide specific elements while keeping add to cart visible
        const addToCartBtn = infoBottom.querySelector('.service-add-cart');
        if (addToCartBtn) {
          addToCartBtn.style.opacity = '1';
          addToCartBtn.style.position = 'relative';
          addToCartBtn.style.zIndex = '2';
        }
      }
    });
    
    container.addEventListener('mousemove', function(e) {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Calculate percentage position
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      
      // console.log(`Mouse position: ${xPercent}%, ${yPercent}%`);
      
      // Set transform origin based on cursor position
      image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      image.style.transform = 'scale(3)';
    });
    
    container.addEventListener('mouseleave', function() {
      // console.log('Mouse left container', index);
      container.classList.remove('zoomed');
      image.style.transform = 'scale(1)';
      image.style.transformOrigin = 'center center';
      image.style.cursor = 'pointer';
      
      // Show the info bottom again
      if (infoBottom) {
        infoBottom.style.opacity = '1';
        
        // Reset any specific element styling if needed
        const addToCartBtn = infoBottom.querySelector('.service-add-cart');
        if (addToCartBtn) {
          addToCartBtn.style.opacity = '';
          addToCartBtn.style.position = '';
          addToCartBtn.style.zIndex = '';
        }
      }
    });
  });
}); 